if (!customElements.get('embla-scroll-trigger')) {
  class EmblaScrollTriggerComponent extends HTMLElement {
    constructor() {
      super();

      this.activeButtonIndex = null;
      this.carousel = this.closest('embla-carousel');
      this.buttons = this.querySelectorAll('button') || null;
    }

    connectedCallback() {
      this.buttons.forEach((button) => {
        button.addEventListener('click', this.handleClick.bind(this));
      });

      const checkEmblaApi = () => {
        if (this.carousel.emblaApi) {
          this.carousel.emblaApi.on('slidesInView', this.handleScroll.bind(this));
        } else {
          setTimeout(checkEmblaApi, 100);
        }
      };

      checkEmblaApi();
    }

    disconnectedCallback() {
      this.buttons.forEach((button) => {
        button.removeEventListener('click', this.handleClick.bind(this));
      });
    }

    handleClick(event) {
      event.preventDefault();
      const target = event.target;
      const index = Number(target.dataset.position) - 1;

      this.carousel.emblaApi.scrollTo(index);
      this.handleActiveStyle(target);
    }

    handleScroll(event) {
      if (this.buttons.length === 0) return;
      const slidesInView = event.slidesInView()[0] + 1;
      const buttonPositions = Array.from(this.buttons).map((button) => Number(button.dataset.position));

      // Find the nearest button index with a position less than or equal to slidesInView
      const nearestIndex = buttonPositions.reduce((prev, curr, index) => {
        if (curr <= slidesInView) {
          return Math.abs(curr - slidesInView) < Math.abs(buttonPositions[prev] - slidesInView) ? index : prev;
        }
        return prev;
      }, 0);

      this.activeButtonIndex = nearestIndex;

      this.buttons.forEach((button) => {
        button.classList.remove('hover-underline-animation--active');
      });

      if (this.activeButtonIndex !== null) {
        this.buttons[this.activeButtonIndex].classList.add('hover-underline-animation--active');
      }
    }

    handleActiveStyle(target) {
      if (target === undefined || this.buttons.length === 0) return;

      this.buttons.forEach((button) => {
        button.classList.remove('hover-underline-animation--active');
      });
      target.classList.add('hover-underline-animation--active');
    }
  }

  customElements.define('embla-scroll-trigger', EmblaScrollTriggerComponent);
}
